import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ADMIN_CATEGORY_INCIDENT,
  CASEINCIDENTS,
  DASHBOARD,
  SETUP_INSPECTION_LIST,
  SW_PERMIT_LIST,
  USERCOURSES,
  USERLESSON,
} from "../../../constant/routeContant";
import "./successScreen.scss";
import commonImages from "../../../assets";
export default function SuccessScreen({
  route,
  id,
  isUpdate,
  label1,
  label2,
  label3,
  label4,
  isImg,
  isClass,
  caseId = null,
  projectData = null,
  isEditModeThroughViewCase = false,
  inspectionData = null,
  establishmentData = null,
  routeProps = null,
  contractorData = null,
  setRemoveSreen,
  setRemoveSceenCourseId,
  isRemoveScreen = false,
  value,
  removeSceenLessonId,
  isQuizScreen = false,
  prevPath,
  courseDetailBackPath,
  routeState = null,
}) {
  const [seconds, setSeconds] = useState(5);
  const navigate = useNavigate();
  const isLessonFlow = !!routeState?.lessonId;
  const backRoute = isLessonFlow ? USERLESSON : USERCOURSES;
  const backRouteText = isLessonFlow ? "Back to Lesson" : "Back to Course";

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);

      return () => clearTimeout(timer);
    }

    if (caseId && isEditModeThroughViewCase) {
      navigate(CASEINCIDENTS, {
        state: { caseId: caseId },
      });
      return;
    }

    if (projectData) {
      navigate(SW_PERMIT_LIST, {
        state: {
          projectid: projectData?.projectid,
          projectName: projectData?.projectName,
          projectNumber: projectData?.projectNumber,
          stateId: projectData?.stateId,
        },
      });
      return;
    }

    if (inspectionData) {
      navigate(SETUP_INSPECTION_LIST, {
        state: {
          projectId: inspectionData?.projectId,
          projectName: inspectionData?.projectName,
          customerName: inspectionData?.customerName,
          customerId: inspectionData?.customerId,
        },
      });
      return;
    }

    if (establishmentData) {
      navigate(ADMIN_CATEGORY_INCIDENT, {
        state: {
          flag: establishmentData?.flag,
        },
      });
      return;
    }

    if (isQuizScreen) {
      navigate(route, {
        state: {
          ...routeState,
          courseId: id,
          route: backRoute,
          routeText: backRouteText,
          removeSceenLessonId: removeSceenLessonId,
          removeSceenValue: value,
          prevPath: prevPath,
          courseDetailBackPath: courseDetailBackPath,
        },
      });
      return;
    }

    if (isRemoveScreen) {
      setRemoveSreen(true);
      setRemoveSceenCourseId(id);
      navigate(route, {
        state: {
          courseId: id,
          route: USERCOURSES,
          routeText: "Back to Course",
          removeSceenLessonId: removeSceenLessonId,
          removeSceenValue: value,
          courseDetailBackPath: courseDetailBackPath,
        },
      });
      return;
    }

    if (routeProps) {
      navigate(route, {
        state: { routeProps: routeProps },
      });
      return;
    }

    if (contractorData) {
      navigate(route, {
        state: { rowsss: contractorData },
      });
      return;
    }

    if (routeState) {
      navigate(route ? route : DASHBOARD, {
        state: routeState,
      });
    } else {
      navigate(route ? route : DASHBOARD);
    }
  }, [seconds]);

  return (
    <div
      className={isClass ? isClass + " successScreenBody" : "successScreenBody"}
    >
      <div className="iconSuccess">
        <img
          src={isImg ? isImg : commonImages.successCheck}
          className="succesImg"
          alt=""
        />
      </div>
      {isUpdate && <div className="heading">{isUpdate}</div>}
      <div className="report">{label1 ? label1 : "Report ID"}</div>
      <div className="CNU">{id}</div>
      <div className="generated">{label2 ? label2 : "has been generated"}</div>
      <div className="redirect">
        {label3 ? label3 : "You will be redirected to"} <br></br>
        {label4 ? label4 : " Home Screen in"} <span>{seconds} second</span>
      </div>
    </div>
  );
}